import { createSlice } from '@reduxjs/toolkit';
import { setDefinitions } from '../actions/SetDefinitions';
const initialState = {};
export const mandolynsSlice = createSlice({
    name: 'mandolyns',
    initialState,
    reducers: {
        mandolynsCleared: () => {
            return {};
        },
        mandolynUpdated: (state, action) => {
            state[action.payload.id] = action.payload;
        },
        mandolynDeleted: (state, action) => {
            delete state[action.payload];
        },
        mandolynsReplaced: (state, action) => {
            const newState = {};
            for (const o of action.payload) {
                newState[o.id] = o;
            }
            return newState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(setDefinitions, (_, action) => {
            const newState = {};
            for (const o of action.payload.mandolyns) {
                newState[o.id] = o;
            }
            return newState;
        });
    }
});
export const selectMandolyns = (state) => state.definitions.mandolyns;
export const selectMandolyn = (id) => (state) => state.definitions.mandolyns[id];
export const { mandolynsCleared, mandolynUpdated, mandolynDeleted, mandolynsReplaced } = mandolynsSlice.actions;
export const hastaTransmitterAdded = mandolynUpdated;
export default mandolynsSlice.reducer;
